var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { MenuItem } from 'material-ui';
import { BrowserRouter, Link, Route } from 'react-router-dom';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import * as React from 'react';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import { configureStore } from '@realcity/web-frame';
import { Base } from '@realcity/web-frame/build/components/Base';
import HomePage from './components/HomePage';
import { websocketEpic } from './websocket';
import reducers from './reducers';
import { maximumSpeedEpic, locationEpic } from './components/MapControl/actions';
import fontawesome from '@fortawesome/fontawesome';
import faBus from '@fortawesome/fontawesome-free-solid/faBus';
import FontAwesome from 'react-fontawesome';
fontawesome.library.add(faBus);
var rootEpic = combineEpics(websocketEpic, maximumSpeedEpic, locationEpic);
var epicMiddleware = createEpicMiddleware(rootEpic);
var store = configureStore(reducers, [epicMiddleware]);
var menu = (React.createElement(React.Fragment, null,
    React.createElement(MenuItem, __assign({ style: { color: '#bdbdbd' }, component: Link }, { to: '/' }), "Dashboard")));
var title = (React.createElement(React.Fragment, null,
    "testdrive\u00A0",
    React.createElement(FontAwesome, { name: "bus" })));
render(React.createElement(Provider, { store: store },
    React.createElement(BrowserRouter, null,
        React.createElement(Base, { title: title, menu: menu, fakeUser: "John Trolley", showToolbar: false },
            React.createElement(Route, { path: "/", component: HomePage })))), document.getElementById('root'));



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 329
// module chunks = 0